import { render } from "./BasePrices.vue?vue&type=template&id=0f0e99b2&scoped=true&ts=true"
import script from "./BasePrices.vue?vue&type=script&lang=ts"
export * from "./BasePrices.vue?vue&type=script&lang=ts"

import "./BasePrices.vue?vue&type=style&index=0&id=0f0e99b2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0e99b2"]])

export default __exports__